import { isFeatureEnabled } from '@atlassiansox/frontend-feature-encoding';
import { isFedRamp } from '@atlassian/atl-context';

import { fg } from '@confluence/feature-gating';
import { isMobileUserAgent, shouldShowMobileWeb } from '@confluence/mobile-detection';
import { AccessStatus } from '@confluence/session-data/entry-points/SiteInformationQuery';

type LoomDisabledProps = {
	accessStatus: AccessStatus;
	isLoggedIn: boolean;
};

/**
 * Checking for if Loom is disabled.
 * Note: This file is a non-hook version of the function useIsLoomDisabled.ts so that it can be run during SSR preloading
 * It will eventually replace the hook after SSR rollout
 */
export const getIsLoomDisabled = ({ accessStatus, isLoggedIn }: LoomDisabledProps) => {
	const isInFedRamp = isFedRamp();
	const isMobile = isMobileUserAgent() || shouldShowMobileWeb();
	// When the gate is ON, we use the feature-encoding SDK to check if the feature is enabled in the current environment
	const isLoomFeatureEnabled = fg('use_frontend_feature_encoding_sdk')
		? isFeatureEnabled('confluence', 'confluence-loom-integration')
		: !isInFedRamp;

	const isLicensed =
		accessStatus == AccessStatus.LICENSED_ADMIN_ACCESS ||
		accessStatus == AccessStatus.LICENSED_USE_ACCESS;

	if (!isLoggedIn || !isLicensed) {
		return true;
	}

	// Disable when feature is not enabled in current environment/evaluation
	if (!isLoomFeatureEnabled) {
		return true;
	}

	// don't enable entry points if user is on a mobile device or viewing mobile web
	if (isMobile) {
		return true;
	}

	return false;
};
